import * as Yup from 'yup';

export const validationSchema = Yup.object({
  email: Yup.string().email('E-mail inválido').required('E-mail obrigatório'),
});
